import { render, staticRenderFns } from "./MakeEfectivoTransaction.vue?vue&type=template&id=2b012f96&scoped=true"
import script from "./MakeEfectivoTransaction.vue?vue&type=script&lang=js"
export * from "./MakeEfectivoTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b012f96",
  null
  
)

export default component.exports